import { getAllSubmissions } from "@/api/store/FormsService.js";

export const state = {
  unprocessedSubmissions: []
};

export const mutations = {
  SET_UNPROCESSED(state, submissions) {
    state.unprocessedSubmissions = submissions;
  }
};

export const getters = {
  unprocessedCount(state) {
    return state.unprocessedSubmissions.length;
  }
};

export const actions = {
  async loadUnprocessed({ commit }) {
    try {
      const all = await getAllSubmissions();
      const unprocessed = all.filter(s => s.is_processed != 1);
      commit("SET_UNPROCESSED", unprocessed);
    } catch (e) {
      // silently fail
    }
  }
};
